import BlockedDomainsOption from 'owa-blocked-domains-option/lib/BlockedDomainsOption';
import { BlockedSendersAndDomainsOptionV2 } from 'owa-blocked-senders-and-domains-option';
import BlockedSendersOption from 'owa-blocked-senders-option/lib/BlockedSendersOption';
import { isFeatureEnabled } from 'owa-feature-flags';
import { FiltersOption } from 'owa-filters-option';
import { initMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import { LazyOption, OptionSubCategory } from 'owa-options-core';
import { ReportingOption } from 'owa-reporting-option';
import SafeMailingListsOption from 'owa-safe-mailing-lists-option/lib/SafeMailingListsOption';
import { SafeMailingListsOptionV2 } from 'owa-safe-mailing-lists-v2-option';
import { SafeSendersDomainsOptionV2 } from 'owa-safe-senders-domains-v2-option';
import SafeSendersOption from 'owa-safe-senders-option/lib/SafeSendersOption';
import { trace } from 'owa-trace';

const junkEmailSubCategory: OptionSubCategory = {
    key: 'junkEmail',
    titleStringKey: 'optionSubcategory_junkEmail',
    options: getJunkEmailOptions(),
    onSelected: () => {
        return loadMailboxJunkEmailConfiguration();
    },
};

export default junkEmailSubCategory;

function getJunkEmailOptions(): LazyOption[] {
    const options: LazyOption[] = [];

    // NOTE: PRESERVE THIS ORDER
    // 1. Blocked sender/domain
    // 2. Safe sender/domain
    // 3. Filters
    // 4. Reporting

    // V2: tri-spamV2SenderDomain enabled
    if (isFeatureEnabled('tri-spamV2SenderDomain')) {
        options.push(
            BlockedSendersAndDomainsOptionV2,
            SafeSendersDomainsOptionV2,
            SafeMailingListsOptionV2
        );
    } else {
        // V1: tri-spamV2SenderDomain disabled
        options.push(
            BlockedSendersOption,
            BlockedDomainsOption,
            SafeSendersOption,
            SafeMailingListsOption
        );
    }

    if (isFeatureEnabled('tri-spamV2')) {
        options.push(FiltersOption, ReportingOption);
    }
    return options;
}

async function loadMailboxJunkEmailConfiguration(): Promise<boolean> {
    try {
        await initMailboxJunkEmailConfiguration();
        return true;
    } catch (e) {
        trace.warn(e.message || 'loadMailboxJunkEmailConfiguration failed');
        return false;
    }
}
